import { Typography, TypographyProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

function Title({
  data,
  sx,
  ..._props
}: {
  data?: { html?: string | null; text?: string | null } | null;
  component?: 'h1' | 'h2' | 'h3' | 'div';
} & TypographyProps): React.JSX.Element {
  const { palette } = useTheme();

  if (!data?.text && !data?.html) return <></>;

  const { text, html } = data;

  const props: TypographyProps = {
    fontSize: '2em',
    fontWeight: 600,
    lineHeight: 1.3,
    sx: {
      ...sx,
      '> p': { margin: 0 },
      strong: { color: palette.secondary.main, fontWeight: 'inherit' },
    },
    variant: 'h6',
    ..._props,
  };

  if (html) {
    return <Typography dangerouslySetInnerHTML={html ? { __html: html } : undefined} {...props} />;
  }

  return <Typography {...props}>{text}</Typography>;
}

export default Title;
